import styled from 'styled-components';
import SectionTitle from '../components/SectionTitle';

const Section = styled.section`
  max-width: 1000px;
  margin: 0 auto;
  padding: 3rem 1.5rem 4rem;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 18px;
  padding: 2rem;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0e7dc;
`;

const Block = styled.section`
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Heading = styled.h3`
  color: #7a1f2b;
  margin-bottom: 0.8rem;
`;

const SubHeading = styled.h4`
  color: #3e352f;
  margin: 1.2rem 0 0.5rem;
`;

const Text = styled.p`
  line-height: 1.8;
  color: #3e352f;
  margin-bottom: 0.8rem;
`;

const List = styled.ul`
  line-height: 1.8;
  color: #3e352f;
  padding-left: 1.4rem;
  margin-bottom: 0.8rem;
`;

const ExternalLink = styled.a`
  color: #7a1f2b;
  font-weight: 700;
  text-decoration: underline;
`;

function DatenschutzPage() {
  return (
    <Section>
      <SectionTitle>Datenschutzerklärung</SectionTitle>

      <Card>
        <Block>
          <Text><strong>Stand:</strong> Mai 2026</Text>
          <Text>
            Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Diese Datenschutzerklärung informiert darüber,
            welche Daten beim Besuch dieser Website und bei der Nutzung des Reservierungsformulars verarbeitet werden.
          </Text>
        </Block>

        <Block>
          <Heading>1. Verantwortlicher</Heading>
          <Text>
            Petra Kausch<br />
            Stadtheuriger zum Brückl<br />
            Wienerstraße 26<br />
            2620 Neunkirchen<br />
            Österreich
          </Text>
          <Text>
            Telefon: 0670 / 3504707<br />
            E-Mail: office@stadtheuriger-neunkirchen.at
          </Text>
        </Block>

        <Block>
          <Heading>2. Hosting und technische Zugriffsdaten</Heading>
          <Text>
            Diese Website wird bei HostProfis betrieben. Beim Aufruf der Website können aus technischen Gründen
            Zugriffsdaten verarbeitet werden, insbesondere IP-Adresse, Datum und Uhrzeit des Zugriffs,
            aufgerufene Seite, Browsertyp, Betriebssystem und Referrer-URL.
          </Text>
          <Text>
            Die Verarbeitung erfolgt zur Bereitstellung der Website, zur technischen Sicherheit, zur Fehleranalyse
            und zur Abwehr von Missbrauch. Rechtsgrundlage ist unser berechtigtes Interesse am sicheren und stabilen
            Betrieb der Website gemäß Art. 6 Abs. 1 lit. f DSGVO.
          </Text>
        </Block>

        <Block>
          <Heading>3. Speisekarte und Google Sheets</Heading>
          <Text>
            Die Inhalte der Speisekarte werden durch uns in einer Google-Tabelle gepflegt. Damit beim Aufruf der
            Website keine direkte Verbindung vom Browser der Besucher zu Google Sheets hergestellt werden muss,
            wird die Speisekarte über eine technische Schnittstelle auf unserem eigenen Webspace geladen und
            zwischengespeichert.
          </Text>
          <Text>
            Der Browser des Besuchers ruft dabei ausschließlich eine Adresse dieser Website auf. Die technische
            Abfrage der Google-Tabelle erfolgt serverseitig durch unseren Webserver. Dadurch wird vermieden, dass
            bereits beim Öffnen der Speisekarte direkt Verbindungsdaten des Besuchers an Google Sheets übertragen werden.
          </Text>
          <Text>
            Die Verarbeitung erfolgt zur Darstellung der aktuellen Speisekarte und damit zur Bereitstellung der
            gewünschten Website-Funktion. Rechtsgrundlage ist unser berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f DSGVO,
            die Speisekarte aktuell, wartbar und technisch zuverlässig anzubieten.
          </Text>
        </Block>

        <Block>
          <Heading>4. Reservierungsformular</Heading>
          <Text>
            Wenn Sie über das Reservierungsformular eine Anfrage senden, verarbeiten wir die von Ihnen eingegebenen Daten.
          </Text>

          <SubHeading>Verarbeitete Daten</SubHeading>
          <List>
            <li>Name</li>
            <li>Telefonnummer</li>
            <li>E-Mail-Adresse</li>
            <li>gewünschtes Datum und gewünschte Uhrzeit</li>
            <li>Personenanzahl</li>
            <li>freiwillige Nachricht oder besondere Wünsche</li>
          </List>

          <SubHeading>Zweck der Verarbeitung</SubHeading>
          <Text>
            Die Daten werden ausschließlich verwendet, um Ihre Reservierungsanfrage zu bearbeiten,
            Rückfragen zu klären und die Reservierung zu bestätigen oder abzusagen.
          </Text>

          <SubHeading>Rechtsgrundlage</SubHeading>
          <Text>
            Die Verarbeitung erfolgt zur Durchführung vorvertraglicher Maßnahmen bzw. zur Bearbeitung Ihrer Anfrage
            gemäß Art. 6 Abs. 1 lit. b DSGVO. Soweit eine weitere Kommunikation erforderlich ist, kann die Verarbeitung
            zusätzlich auf unserem berechtigten Interesse an einer ordnungsgemäßen Kommunikation gemäß Art. 6 Abs. 1 lit. f DSGVO beruhen.
          </Text>

          <SubHeading>Weiterleitung über Web3Forms</SubHeading>
          <Text>
            Für die technische Übermittlung des Reservierungsformulars verwenden wir den Dienst Web3Forms
            (web3forms.com). Die eingegebenen Formularinhalte werden an Web3Forms übermittelt und von dort per E-Mail
            an uns weitergeleitet.
          </Text>
          <Text>
            Weitere Informationen zur Datenverarbeitung durch Web3Forms finden Sie unter:{' '}
            <ExternalLink href="https://web3forms.com/privacy" target="_blank" rel="noreferrer">
              https://web3forms.com/privacy
            </ExternalLink>
          </Text>
        </Block>

        <Block>
          <Heading>5. Kontaktaufnahme per Telefon oder E-Mail</Heading>
          <Text>
            Wenn Sie uns telefonisch oder per E-Mail kontaktieren, verarbeiten wir die von Ihnen bekanntgegebenen Daten
            zur Bearbeitung Ihrer Anfrage. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, wenn Ihre Anfrage mit einer
            Reservierung oder einem möglichen Vertragsverhältnis zusammenhängt, sowie Art. 6 Abs. 1 lit. f DSGVO für
            allgemeine Kommunikation.
          </Text>
        </Block>

        <Block>
          <Heading>6. Speicherdauer</Heading>
          <Text>
            Personenbezogene Daten werden nur so lange gespeichert, wie dies für die Bearbeitung der Anfrage,
            die Reservierungsabwicklung und die Erfüllung gesetzlicher Pflichten erforderlich ist.
          </Text>
          <Text>
            Reine Reservierungsanfragen, aus denen keine weiteren gesetzlichen Aufbewahrungspflichten entstehen,
            werden regelmäßig gelöscht, sobald sie nicht mehr benötigt werden. Geschäftsrelevante Unterlagen können
            entsprechend gesetzlicher Aufbewahrungspflichten länger gespeichert werden.
          </Text>
        </Block>

        <Block>
          <Heading>7. Cookies, Tracking und Analyse</Heading>
          <Text>
            Diese Website verwendet derzeit keine Analyse- oder Marketing-Cookies und kein Tracking zu Werbezwecken.
            Ein Cookie-Banner ist daher für den aktuellen Stand der Website nicht erforderlich.
          </Text>
          <Text>
            Falls künftig Dienste wie Google Analytics, eingebettete Karten, Social-Media-Plugins oder Marketing-Tools
            eingebunden werden, wird diese Datenschutzerklärung entsprechend angepasst und, soweit erforderlich,
            ein Einwilligungsbanner eingebunden.
          </Text>
        </Block>

        <Block>
          <Heading>8. Ihre Rechte</Heading>
          <Text>
            Sie haben nach Maßgabe der DSGVO insbesondere folgende Rechte:
          </Text>
          <List>
            <li>Recht auf Auskunft über die verarbeiteten personenbezogenen Daten</li>
            <li>Recht auf Berichtigung unrichtiger Daten</li>
            <li>Recht auf Löschung</li>
            <li>Recht auf Einschränkung der Verarbeitung</li>
            <li>Recht auf Datenübertragbarkeit</li>
            <li>Recht auf Widerspruch gegen bestimmte Verarbeitungen</li>
          </List>
          <Text>
            Zur Ausübung Ihrer Rechte können Sie uns über die oben genannten Kontaktdaten kontaktieren.
          </Text>
        </Block>

        <Block>
          <Heading>9. Beschwerderecht</Heading>
          <Text>
            Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen Datenschutzrecht verstößt,
            können Sie sich bei der zuständigen Datenschutzaufsichtsbehörde beschweren.
          </Text>
          <Text>
            Österreichische Datenschutzbehörde<br />
            Barichgasse 40-42<br />
            1030 Wien<br />
            Website:{' '}
            <ExternalLink href="https://www.dsb.gv.at" target="_blank" rel="noreferrer">
              https://www.dsb.gv.at
            </ExternalLink>
          </Text>
        </Block>

        <Block>
          <Heading>10. Änderungen dieser Datenschutzerklärung</Heading>
          <Text>
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich technische, rechtliche oder
            organisatorische Änderungen ergeben.
          </Text>
        </Block>
      </Card>
    </Section>
  );
}

export default DatenschutzPage;